"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[906],{

/***/ 26655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_icons_filter_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24495);
/* harmony import */ var _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97274);
/* harmony import */ var _public_icons_grid_on_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7520);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18216);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);







const PLPLoader = (props)=>{
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const [rowCols, setRowCols] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setRowCols(width < _constants_index__WEBPACK_IMPORTED_MODULE_6__.ROW_COLUMN_MIN_WIDTH ? 2 : 3);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__sticky-nav-wrap",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-fluid product-listing__sticky-nav false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-listing__row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container kf-react-plp-container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-listing__row",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__col product-listing__controls",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "product-listing__total shimmer-loading__para30 shimmer width-240"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                                    className: "sorting-section",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "product-listing__fillter_sort",
                                                            children: "Filter & Sort"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                            id: "showFilter",
                                                            "aria-label": "Show Filters",
                                                            className: "product-listing__filter-toggle gbh-data-layer",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    className: "product-listing__filter-toggle-text  product-listing__filter-toggle-text--show hideMobile\n                            }",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "show",
                                                                            children: "Hide Filters"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "hide",
                                                                            children: "Hide Filters"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: _public_icons_filter_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                                                    className: "product-listing__filter-toggle-icon",
                                                                    alt: "Toggle Filter"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "product-listing__grid-control",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "d-block d-sm-none",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    className: "product-listing__grid-control-icon",
                                                                    src: _public_icons_grid_on_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                                                    alt: "grid on"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "sort",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                    className: "sort__toggle",
                                                                    tabIndex: "0",
                                                                    "aria-label": "Featured selected",
                                                                    children: [
                                                                        "Sort By: Featured",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                                                            alt: "Sort",
                                                                            className: "sort__toggle-icon",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    className: "sort__drop-down",
                                                                    "aria-label": "Sort By Button Closed",
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-0",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "true",
                                                                            className: "sort__item gbh-data-layer active",
                                                                            children: "Featured"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-1",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "Price: High - Low"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-2",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "Price: Low - High"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-3",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "A - Z"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-4",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "Z - A"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing kf-react-plp-container product-listing__tiles",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col product-listing__tile-col product-listing__tile-col--full-width",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "product-listing__filter borderNone",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "filter__inner-container shimmer height-300"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "filter__footer",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "products-per-page width-240 mt60 mb20",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "shimmer-loading__headpara shimmer"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "products-per-page width-100",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "product-listing__tile-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__row row-cols-".concat(rowCols),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " product-listing__tile product-listing__col px-1 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PLPLoader);


/***/ }),

/***/ 30906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_ProductList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./i18n/useProductListi18n.js
var useProductListi18n = __webpack_require__(32908);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.module.scss
var index_module = __webpack_require__(58088);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(68167);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx + 1 modules
var stickyNavHeader = __webpack_require__(79378);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/ProductListView/productListHelper.js
const keyPress = (e, filterModalRef, cb)=>{
    const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
    const focusContent = filterModalRef.current.querySelectorAll(focusElements);
    const firstElem = focusContent[0];
    const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
    if (e.key === "Escape") {
        cb(false);
    }
    if (e.key === "Tab") {
        if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalRef.current)) {
            e.preventDefault();
            lastElem.focus();
        }
        if (!e.shiftKey && document.activeElement === lastElem) {
            e.preventDefault();
            firstElem.focus();
        }
    }
};
const getIsPresentOnDevice = (isHideOnDesktop, isHideOnMobile)=>{
    if (isHideOnMobile === "true" && isHideOnDesktop === "true") {
        return false;
    }
    let showDefaultBehaviour = isHideOnDesktop === undefined && isHideOnMobile === undefined;
    showDefaultBehaviour = showDefaultBehaviour || isHideOnMobile === "false" && isHideOnDesktop === "false";
    if (showDefaultBehaviour) {
        return true;
    }
    const isPresentOnDeskTop = window.matchMedia("(min-width: 1280px)").matches;
    if (isHideOnDesktop === "true") {
        return isPresentOnDeskTop;
    }
    return isHideOnMobile === "true" ? !isPresentOnDeskTop : isPresentOnDeskTop;
};

// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.jsx + 3 modules
var Filter = __webpack_require__(61304);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(55266);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(20711);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/Pagination/index.jsx
var Pagination = __webpack_require__(57633);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.jsx + 1 modules
var ProductTile = __webpack_require__(1866);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/product.js
var utils_product = __webpack_require__(29843);
// EXTERNAL MODULE: ./src/components/PromoBanner/v2/PromoBanner.jsx
var PromoBanner = __webpack_require__(67098);
// EXTERNAL MODULE: ./src/hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83839);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/ProductListView/index.jsx




















const ProductListView = (props)=>{
    const { facets , staticTexts , sorts , selectedSort , loading , data , onSort , onFilter , totalResults , onLoadMore , curRows , displayPrint , displayShare , onRows , productsPerPage , facetLabels , colors , info , isLandscape , defaultImageTag , hoverImageTag , favorites , currFilters , presetConfigs , fusionQueryId , isGrouped , promoLayout , xfHtml , promoPlacementMobile , promoPlacementDesktop , compareData , promoJson , setPromoData , promoData , sessionId ="" , plpBadge ={} , presentOnDesktop ="" , presentOnMobile =""  } = props;
    const { currencySign  } = info;
    const [width] = (0,useWindowResize/* default */.Z)();
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [swatchCount, setSwatchCount] = (0,react.useState)(width > 812 ? 7 : 5);
    const plpRef = (0,react.useRef)(null);
    const filterModalWindow = (0,react.useRef)(null);
    const [showFilter, setShowFilter] = (0,react.useState)(false);
    const [rowCols, setRowCols] = (0,react.useState)(width <= 1280 ? 2 : 3);
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    (0,react.useEffect)(()=>{
        if (width <= 1280) {
            setRowCols(2);
        } else {
            setRowCols(3);
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (!showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref;
            (ref = document.getElementById("showFilter")) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        showFilter
    ]);
    // calculate promo position
    const col = width < 768 ? {
        "one-column": "promo-col-3",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : width > 768 && width < 1281 ? {
        "one-column": "promo-col-1",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : {
        "one-column": "promo-col-1",
        "two-column": "promo-col-2",
        "three-column": "promo-col-3"
    };
    const colVal = {
        "one-column": 1,
        "two-column": 2,
        "three-column": 3
    };
    const row = lib/* isMobile */.tq ? parseInt(promoPlacementMobile) : parseInt(promoPlacementDesktop);
    const position = width <= 1280 ? rowCols === 1 ? row - 1 : row * rowCols - (colVal[promoLayout] === 1 && width > 767 ? 1 : 2) : row * rowCols - colVal[promoLayout];
    const executeScroll = ()=>{
        var ref;
        plpRef === null || plpRef === void 0 ? void 0 : (ref = plpRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(()=>{
        const handleResize = ()=>setSwatchCount((0,helper/* getSwatchCount */.m3S)(true));
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleKeyPress = (e)=>{
        if (width < 992) {
            keyPress(e, filterModalWindow, setShowFilter);
        }
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleSort = (sort)=>{
        onSort(sort);
        executeScroll();
    };
    let promoIndex = 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-listing",
            ref: plpRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader["default"], {
                    showFilter: showFilter,
                    rowCols: rowCols,
                    setShowFilter: setShowFilter,
                    setRowCols: setRowCols,
                    staticTexts: staticTexts,
                    sorts: sorts,
                    selectedSort: selectedSort,
                    handleSort: handleSort,
                    totalResults: totalResults
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-plp-container product-listing__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__row d-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    "aria-modal": true,
                                    ref: filterModalWindow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__filter--sticky",
                                        "aria-hidden": !showFilter,
                                        onKeyDown: handleKeyPress,
                                        children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                            tabIndex: "0",
                                            texts: staticTexts,
                                            close: setShowFilter,
                                            showFilter: showFilter,
                                            addToUrl: true,
                                            showSort: width <= 991,
                                            sort: sorts,
                                            selectedSort: selectedSort,
                                            facetData: facets,
                                            totalResults: totalResults,
                                            loading: loading,
                                            colors: colors,
                                            facetLabels: facetLabels,
                                            onFilter: onFilter,
                                            onSortChange: handleSort,
                                            displayShare: displayShare,
                                            displayPrint: displayPrint,
                                            currFilters: currFilters
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: tileClass,
                                    children: (data === null || data === void 0 ? void 0 : data.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__no-results",
                                        dangerouslySetInnerHTML: {
                                            __html: browser_default().sanitize(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.noResultsMssg)
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-listing__row row-cols-".concat(rowCols),
                                                children: data === null || data === void 0 ? void 0 : data.map((product, i)=>// console.log( xfHtml && (i + 1) % position === 0)
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-listing__tile",
                                                                id: product["masterCustomerFacingSKU_s"],
                                                                children: i < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                        rowCols: rowCols,
                                                                        tabIndex: "0",
                                                                        loading: loading,
                                                                        data: product,
                                                                        mapImageToColor: true,
                                                                        texts: staticTexts,
                                                                        lite: !isLandscape && lib/* isMobile */.tq && rowCols === 2,
                                                                        addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                        removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                        compareData: compareData,
                                                                        defaultImage: defaultImageTag,
                                                                        hoverImage: hoverImageTag,
                                                                        currencySign: currencySign,
                                                                        isGrouped: isGrouped,
                                                                        swatchCount: swatchCount,
                                                                        favorites: favorites,
                                                                        currFilters: currFilters,
                                                                        selectedSort: selectedSort,
                                                                        plpPage: true,
                                                                        index: i,
                                                                        presetConfigs: presetConfigs,
                                                                        fusionQueryId: fusionQueryId,
                                                                        parent: "PLP",
                                                                        sessionId: sessionId,
                                                                        plpBadge: plpBadge
                                                                    })
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s, "-LAZY")) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                        className: "kf-lazyload-wrapper",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                            rowCols: rowCols,
                                                                            tabIndex: "0",
                                                                            loading: loading,
                                                                            data: product,
                                                                            mapImageToColor: true,
                                                                            texts: staticTexts,
                                                                            lite: !isLandscape && lib/* isMobile */.tq && rowCols === 2,
                                                                            addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                            removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                            compareData: compareData,
                                                                            defaultImage: defaultImageTag,
                                                                            hoverImage: hoverImageTag,
                                                                            currencySign: currencySign,
                                                                            isGrouped: isGrouped,
                                                                            swatchCount: swatchCount,
                                                                            favorites: favorites,
                                                                            currFilters: currFilters,
                                                                            selectedSort: selectedSort,
                                                                            plpPage: true,
                                                                            index: i,
                                                                            presetConfigs: presetConfigs,
                                                                            fusionQueryId: fusionQueryId,
                                                                            parent: "PLP",
                                                                            sessionId: sessionId,
                                                                            plpBadge: plpBadge
                                                                        })
                                                                    })
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s, "-LAZY"))
                                                            }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)),
                                                            xfHtml && getIsPresentOnDevice(presentOnDesktop, presentOnMobile) && (i + 1) % position === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(col[promoLayout], " product-listing__tile"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner/* default */.Z, {
                                                                    promoJson: promoJson,
                                                                    xfLink: xfHtml,
                                                                    col: colVal[promoLayout],
                                                                    setPromoData: setPromoData,
                                                                    position: i,
                                                                    promoIndex: ++promoIndex,
                                                                    promoData: promoData,
                                                                    smartCrop: smartCrop,
                                                                    width: width,
                                                                    onFilter: onFilter
                                                                })
                                                            })
                                                        ]
                                                    }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                page: "plp",
                                                totalResults,
                                                staticTexts,
                                                onLoadMore,
                                                curRows,
                                                data,
                                                displayPrint,
                                                displayShare,
                                                productsPerPage,
                                                onRows,
                                                handleBackToTop,
                                                width
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v2_ProductListView = (ProductListView);

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./src/components/ProductList/v2/PLPLoader/index.jsx
var PLPLoader = __webpack_require__(26655);
// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
// EXTERNAL MODULE: ./src/hooks/usePrevious.js
var usePrevious = __webpack_require__(97349);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/analytics.js



const addAnalyticsShowEvent = function(promo, setPromoData) {
    let data = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    let promoData = promo.filter((promo)=>promo && promo.ctaLink);
    promoData.sort((a, b)=>a.position - b.position);
    promoData = getUniqueList(promoData, "position");
    let slot = 1;
    const component = [];
    promoData.forEach((promoItem)=>{
        let title = promoItem.desc || "";
        if (title) {
            var ref;
            const div = document.createElement("div");
            div.innerHTML = title;
            // This contains HTML code so remove some bugs here.
            title = (ref = div.innerText || div.textContent || "") === null || ref === void 0 ? void 0 : ref.toLowerCase();
            title = title.replace(/\n/g, "");
        }
        promoItem.componentInfo = {
            componentID: "".concat(window.location.origin).concat(promoItem.ctaLink),
            componentMessage: "promo-".concat(slot++),
            componentName: title,
            componentLocation: "plp:promo tiles",
            componentType: "internal campaign"
        };
        component.push({
            componentInfo: promoItem.componentInfo
        });
    });
    setPromoData({
        promos: promoData,
        isUpdate: false
    });
    if (!(0,helper/* isShowAnalyticsEventLoaded */.xJ2)()) {
        const page = window.pageObj || {};
        page.user = (0,helper/* getUserAnalyticsObject */.L7i)();
        if (page.category) {
            page.category.room = data && data[0] && data[0].category1_s ? (0,helper/* sanitizeTextForAnalytics */.T68)(data[0].category1_s) : "n/a";
        } else {
            page.category = {
                room: data && data[0] && data[0].category1_s ? (0,helper/* sanitizeTextForAnalytics */.T68)(data[0].category1_s) : "n/a"
            };
        }
        if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
            page.component = component;
            window.pageObj = page;
            window.isShowAnalyticsEvent = true;
        } else {
            window.adobeDataLayer.push({
                event: "cmp:show",
                page: page,
                component: component
            });
        }
    } else {
        var ref, ref1;
        const page1 = window.pageObj;
        page1.category.subCategoryName = (constants.SEAT_TYPES === null || constants.SEAT_TYPES === void 0 ? void 0 : constants.SEAT_TYPES.includes((ref = data[0]) === null || ref === void 0 ? void 0 : ref.Product_Category)) ? constants.SEAT_TYPES === null || constants.SEAT_TYPES === void 0 ? void 0 : constants.SEAT_TYPES.join(", ") : (ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1.Product_Category;
    }
};
const getUniqueList = (arr, key)=>{
    return [
        ...new Map(arr.map((item)=>[
                item[key],
                item
            ])).values()
    ];
};
const getClickSignalPayload = (param)=>{
    let { highlightText , productCategory , siteName , sku , ...props } = param;
    const userInfo = window.adobeDataLayer.getState("page.user.authStatus") === "anonymous" ? "guest" : window.adobeDataLayer.getState("page.user.commerceToolsID");
    const sTimeStamp = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0] + "Z";
    return [
        {
            params: {
                query: highlightText !== null && highlightText !== void 0 ? highlightText : productCategory,
                app_id: siteName.toLowerCase(),
                doc_id: props.data.id,
                fusion_query_id: props.fusionQueryId,
                ctype: props.parent,
                user_id: userInfo,
                country: "USA",
                region: "Northeast",
                item_pos: props.index,
                plc: productCategory,
                sku_id: props.data.sku_s,
                session_id: props === null || props === void 0 ? void 0 : props.sessionId,
                count_i: "1",
                url: window.location
            },
            id: "".concat(new Date().valueOf(), "_").concat(userInfo, "_").concat(sku, " "),
            timestamp: sTimeStamp,
            type: "click"
        }
    ];
};
const triggerClickSignal = async (param)=>{
    let { highlightText , productCategory , siteName , sku , ...props } = param;
    const aSignalsPayload = getClickSignalPayload({
        highlightText,
        productCategory,
        siteName,
        sku,
        ...props
    });
    await apim.post("/search/signals/".concat(siteName.toLowerCase()), aSignalsPayload);
};


// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var ProductsTab_helper = __webpack_require__(34955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/ProductList.jsx

























const ProductList = (props)=>{
    var ref;
    const isServer = "object" === "undefined";
    const isSsr = (0,useIsSsr/* default */.Z)();
    const router = (0,next_router.useRouter)();
    let plp;
    let compareData;
    const { eventHandler  } = props;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const DEFAULT_PAGINATION_VALUE = constants.DEFAULT_PRODUCT_COUNT_PLP;
    const { data: componentProps  } = props;
    const { access_token: accessToken , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { categoryKey , attributevalue , attributeName , isServiceParts =""  } = componentProps;
    if (isServer) {
        var ref1;
        plp = eventHandler === null || eventHandler === void 0 ? void 0 : (ref1 = eventHandler.store) === null || ref1 === void 0 ? void 0 : ref1.plp;
        compareData = {};
    } else {
        // eslint-disable-next-line
        plp = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
        // eslint-disable-next-line
        compareData = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    }
    const dispatch = (0,es/* useDispatch */.I0)();
    const { data , total =0 , facets , facetLabels , status , initialLoad , colors , grouped , fusion ={}  } = plp;
    const rowsInitialValue = (0,utils_product/* getRowsInitialValue */.U9)();
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: rowsInitialValue,
        start: 0
    });
    const { rows , start  } = paginationState;
    const [promoData, setPromoData] = (0,react.useState)({
        promos: [],
        isUpdate: false
    });
    const prevRows = (0,usePrevious/* default */.Z)(rows);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)({
        brandName: "",
        badgeText: ""
    });
    const [sessionId, setSessionId] = (0,react.useState)("") // setting initial state of sessionId
    ;
    // Need to read from env file
    const [info, setInfo] = (0,react.useState)({
        currencyCode: "USD",
        currencySign: "$",
        locale: "en-US"
    });
    const [state, setState] = (0,react.useState)({
        position: "",
        promoJson: {}
    });
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    const [curFilterQueries, setCurFilterQueries] = (0,react.useState)(null);
    const prevCurFilterQueries = (0,usePrevious/* default */.Z)(curFilterQueries);
    const [persona, setPersona] = (0,react.useState)("GST");
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [filterDataPopulated, setFilterDataPopulated] = (0,react.useState)(false);
    const [plpBadge, setPlpBadge] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        (0,config/* getConfig */.i)().then((config)=>{
            const { plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
            const locale = get_default()(config, "internationalization.locale", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const brandName = get_default()(config, "general.siteName");
            var ref;
            const displayOrderBadges = (ref = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref !== void 0 ? ref : {};
            const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
            const plpBadges = {};
            displayOrderBadgeList.forEach((item)=>{
                plpBadges[item] = (0,helper/* getBadgeValue */.FcF)(item, plpBadgeList);
            });
            const badgeText = {
                new: get_default()(config, "general.newBadgeName", ""),
                onSale: get_default()(config, "general.saleBadgeName", ""),
                exclusive: get_default()(config, "general.exclusiveBadgeName", "")
            };
            const marketParamValues = get_default()(config, "marketParamValues", {});
            const { general: { serviceParts =""  } = {}  } = config;
            const general = {
                brandName: brandName,
                badgeText: badgeText,
                serviceParts
            };
            const info = {
                locale: locale,
                currencyCode: currencyCode,
                currencySign: currencySign,
                marketParamValues
            };
            const filterQuery = (0,helper/* getAllFilterQueries */.ud4)(componentProps, fusion, marketParamValues);
            setCurFilterQueries(filterQuery);
            setGeneral(general);
            setInfo(info);
            setPlpBadge({
                plpBadges,
                displayOrderBadgeList
            });
            const cookie = document === null || document === void 0 ? void 0 : document.cookie;
            const cookieArray = cookie === null || cookie === void 0 ? void 0 : cookie.split(";");
            const sessionCookie = cookieArray.filter((item)=>{
                return item === null || item === void 0 ? void 0 : item.includes("session#");
            })[0];
            const sessionIdString = sessionCookie === null || sessionCookie === void 0 ? void 0 : sessionCookie.split("|")[1];
            setSessionId(sessionIdString === null || sessionIdString === void 0 ? void 0 : sessionIdString.split("#")[1]) // setting the value of session id from cookie information
            ;
        });
    }, [
        isSsr,
        router
    ]);
    const staticTexts = (0,useProductListi18n/* default */.Z)({
        componentProps,
        total: total,
        generalRef: general
    });
    const [selectedSort, setSelectedSort] = (0,react.useState)({
        name: staticTexts.featured,
        query: ""
    });
    const prevSort = (0,usePrevious/* default */.Z)(selectedSort);
    const sorts = [
        {
            name: staticTexts.featured,
            query: ""
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "".concat(grouped ? "CollapseSort_s+asc" : "NonCollapseSort_s+asc")
        },
        {
            name: staticTexts.ztoa,
            query: "".concat(grouped ? "CollapseSort_s+desc" : "NonCollapseSort_s+desc")
        }
    ];
    const handleSort = (selectedSort)=>{
        (0,helper/* replaceSearchUrl */.CjH)("sort", selectedSort.query);
        setPaginationState((state)=>({
                ...state,
                start: 0
            }));
        setSelectedSort(selectedSort);
    };
    const handleLoadMore = ()=>{
        setRowsSession(start + rows + rows);
        setPaginationState((state)=>({
                ...state,
                start: start + rows
            }));
        setIsLoadMore(true);
    };
    const setRowsSession = (rows)=>{
        if (sessionStorage.rows) {
            const rowStorage = JSON.parse(sessionStorage.rows);
            rowStorage[window.location.pathname] = rows;
            sessionStorage.rows = JSON.stringify(rowStorage);
        } else {
            sessionStorage.rows = JSON.stringify({
                [window.location.pathname]: rows
            });
        }
    };
    const handleRows = (rows)=>{
        setPaginationState({
            rows,
            start: 0
        });
        setRowsSession(rows);
    };
    (0,react.useEffect)(()=>{
        if (accessToken && curFilterQueries !== null) {
            var ref, ref1;
            const personaTemp = (user === null || user === void 0 ? void 0 : (ref = user.persona) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (ref1 = user === null || user === void 0 ? void 0 : user.persona[0]) === null || ref1 === void 0 ? void 0 : ref1.split(":")[1] : "GST";
            setPersona(personaTemp);
            window.authAccessToken = accessToken;
            // will trigger from handleLoadMore
            if (start) {
                generateListingUrl(isLoadMore, false);
            } else if (start == 0 && rows && !!prevRows && prevRows > rows) {
                generateListingUrl(false, true);
            } else if (start == 0 && rows && !!prevRows && prevRows != rows) {
                generateListingUrl(false, false);
            } else if (curFilterQueries.length > 0 || (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (curFilterQueries.length === 0 && prevCurFilterQueries != null) {
                generateListingUrl();
            } else if (prevSort && (prevSort === null || prevSort === void 0 ? void 0 : prevSort.query) != (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query)) {
                generateListingUrl();
            } else if (prevRows == rows && rows > DEFAULT_PAGINATION_VALUE || personaTemp != "GST") {
                generateListingUrl();
            }
        }
    }, [
        start,
        rows,
        accessToken,
        curFilterQueries,
        selectedSort,
        isLoadMore
    ]);
    (0,react.useEffect)(()=>{
        if (!(attributevalue && attributeName)) {
            if (!data || data && data.length === 3 && total > 3) {
                generateListingUrl();
            }
        }
    }, [
        data,
        total,
        attributevalue,
        attributeName
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(fusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            const fusionQueryId = fusion === null || fusion === void 0 ? void 0 : fusion.fusionQueryId;
            setFusionQueryId(fusionQueryId);
            const sortUrl = (0,helper/* getSortFromUrl */.aN0)();
            const sortQuery = (0,helper/* getSelectedSort */.a4K)(staticTexts, sortUrl);
            setSelectedSort(sortQuery);
            if (componentProps) {
                if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfLink) {
                    setState({
                        ...state,
                        xfHtml: componentProps.xfLink
                    });
                } else {
                // log.warn("Promo banner xF is not configured")
                }
            } else {
            // log.warn("Product List: Get URL Property not found")
            }
        }
    }, [
        fusion,
        accessToken
    ]);
    // Function to generate the plp request url.
    const generateListingUrl = async function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const queries = curFilterQueries;
        if (!update) {
            setPaginationState({
                ...paginationState,
                start: 0
            });
            setPromoData({
                promos: [],
                isUpdate: false
            });
        }
        const fq = [];
        const persona = (0,helper/* getUserPersona */.shu)();
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>{
            const tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 ? fq.push(encodeURIComponent("".concat('{!tag="priceList.'.concat(persona, '.finalPrice_d"}') + "priceList.".concat(persona, ".finalPrice_d"), ":(").concat(q.value.join(" OR "), ")"))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            q.facet === "Price_Range" || q.facet.indexOf("priceList") === 0 ? fq.push("".concat("priceList.".concat(persona, ".finalPrice_d").replace(/^\*{2}/, ""), ":(").concat(encodeURIComponent(q.value), ")")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        const query = {
            fq,
            rows,
            start,
            fl: constants.resourceFacetLabels.join(",")
        };
        if (selectedSort.query) {
            if (selectedSort.query === "price+asc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+asc");
            } else if (selectedSort.query === "price+desc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(plp === null || plp === void 0 ? void 0 : plp.grouped), "+desc");
            } else {
                query.sort = selectedSort.query;
            }
        }
        if (enableScroll) setDataPopulated(false);
        const globalConfig = await (0,config/* getConfig */.i)();
        const { general: { serviceParts =""  } = {}  } = globalConfig;
        const collections = isServiceParts ? serviceParts : "";
        dispatch((0,productListSlice/* getProducts */.Xp)({
            profileName: categoryKey,
            query,
            update,
            collections
        })).then(()=>{
            setFilterDataPopulated(true);
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            setFilterDataPopulated(true);
            if (enableScroll) setDataPopulated(false);
        });
    };
    const setPromoInfo = (promo)=>{
        const promoDataNew = [
            ...promoData.promos
        ];
        if (promo && !promoData.promos.find((item)=>item.position === promo.position)) {
            // don't push duplicates
            promoDataNew.push(promo);
        }
        setPromoData({
            promos: promoDataNew,
            isUpdate: true
        });
    };
    (0,react.useEffect)(()=>{
        // checking if all responses are recorded
        if (isSsr) return;
        const { isUpdate , promos  } = promoData;
        if (isUpdate) {
            const { position  } = state;
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === promos.length) {
                addAnalyticsShowEvent(promos, setPromoData, data);
            }
        }
    }, [
        promoData.promos,
        promoData.isUpdate,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        if (isSsr) return;
        // plpLoadedEvent implementation
        const { position , xfHtml  } = state;
        const { promos  } = promoData;
        if (!data || !data.length || parseInt(data.length / position) === 0 || !xfHtml) {
            addAnalyticsShowEvent(promos, setPromoData, data);
        } else {
            // checking if all responses are recorded
            const requestedPromos = [];
            data.map((item, i)=>{
                if ((i + 1) % position === 0) {
                    requestedPromos.push(i);
                }
            });
            if (requestedPromos.length === 0) {
                addAnalyticsShowEvent(promos, setPromoData, data);
            } else {
                setTimeout(()=>{
                    addAnalyticsShowEvent(promos, setPromoData, data);
                }, 5000);
            }
        }
    }, [
        data,
        state.position,
        componentProps.xfLink,
        isSsr
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,ProductsTab_helper/* scrollToProduct */.C1)();
    }, [
        dataPopulated
    ]);
    const sendPositionToParent = (position)=>{
        setState({
            ...state,
            position: position
        });
    };
    const handleFilter = (appliedFilter)=>{
        setRowsSession(30);
        setIsLoadMore(false);
        setCurFilterQueries(appliedFilter);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isEmpty_default()(info) && (!(attributeName && attributevalue) || attributevalue && attributeName && filterDataPopulated) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-testid": "product-list",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_ProductListView, {
                staticTexts: staticTexts,
                sorts: sorts,
                selectedSort: selectedSort,
                info: info,
                onLoadMore: handleLoadMore,
                curRows: rows,
                onRows: handleRows,
                onSort: handleSort,
                onFilter: handleFilter,
                totalResults: total,
                displayShare: componentProps.enableSharePlp,
                displayPrint: componentProps.enablePrintPlp,
                productsPerPage: productsPerPage,
                data: data,
                colors: colors,
                loading: initialLoad ? false : status !== "succeeded",
                ...componentProps,
                facets: facets !== null && facets !== void 0 ? facets : false,
                facetLabels: facetLabels,
                xfHtml: state.xfHtml,
                currFilters: curFilterQueries,
                // resetTitle={""} The value is not using any where, so not implemented now
                // urlTitle={""} The value is not using any where, so not implemented now
                isGrouped: grouped,
                favorites: (ref = (0,helper/* getFavouraties */.MqV)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                setPromoData: setPromoInfo,
                sendPositionToParent: sendPositionToParent,
                promoData: promoData.promos,
                promoJson: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) ? JSON.parse(componentProps === null || componentProps === void 0 ? void 0 : componentProps.xfjson) : {},
                fusionQueryId: fusionQueryId,
                parent: "PLP",
                compareData: compareData,
                promoLayout: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoLayout,
                promoPlacementDesktop: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementDesktop,
                promoPlacementMobile: componentProps === null || componentProps === void 0 ? void 0 : componentProps.promoPlacementMobile,
                persona: persona,
                sessionId: sessionId,
                plpBadge: plpBadge
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {})
        })
    });
};
/* harmony default export */ var v2_ProductList = (ProductList);


/***/ })

}]);